import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams, HttpErrorResponse } from "@angular/common/http";
import { Label, CacheService, ITagBO, ITagLanguageBO } from '@mapfre-tech/amap3';
import { Observable, of, Subject } from "rxjs";
import moment from 'moment';
import { map, tap } from 'rxjs/operators';
import * as _ from 'lodash';
import { Router } from '@angular/router';

@Injectable({
   providedIn: "root"
})
export class LabelService {

   className = 'LabelService';

   memoryCache = {
      "labels": {
         "data": null,
         "lastReqDate": null
      }
   }

   sections = [
      'administration',
      'works/dashboard',
      'recommendations/dashboard',
      'following'      
   ]

   constructor(private http: HttpClient, private cacheService: CacheService, private router: Router) { }

   getAllLabels(showJob = true, showRdn = true): Observable<ITagBO[]>  {
      const cache = true;
      const params: any = {};
      params.showJob = showJob;
      params.showRdn = showRdn;
      const isSection = _.some(this.sections, section => _.includes(this.router.url, section));
      const cacheKey = "labels"+"_"+showJob.toString()+"_"+showRdn.toString()+"_"+isSection.toString();

      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey) as object as Observable<ITagBO[]>;
      } else {
         const observable = this.http.get<ITagBO[]>(environment.base_URL + "/tags", { params }).pipe(map((res: ITagBO[]) => {
            if(isSection){
               this.cacheService.updateCacheData(res, cacheKey)
               return res;
            }else{
               const filtrado: ITagBO[] = res.filter((it): it is ITagBO => it.mrkActive === true);
               this.cacheService.updateCacheData(filtrado, cacheKey)
               return filtrado;
            }
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
      }
   }

   getLabelById(id: number): Observable<Label> {
      return this.http.get<Label>(environment.base_URL + `/tags/${id}`)
   }

   newLabel(label: ITagBO) {
      return this.http.post(environment.base_URL + "/tags", label).pipe(tap(() => this.deleteCache()))
   }

   updateLabel(label: ITagBO, id: number) {
      return this.http.put(environment.base_URL + `/tags/${id}`, label).pipe(tap(() => this.deleteCache()))
   }

   deleteLabel(id: number) {
      return this.http.delete(environment.base_URL + `/tags/${id}`).pipe(tap(() => this.deleteCache()))
   }

   createTranslation(translation: ITagLanguageBO, tagId: number) {
      //Idlanguage & txtValor
      return this.http.post(environment.base_URL + `/tags/translations/${tagId}`, translation)
   }
   updateTranslation(label: ITagLanguageBO, relationId: number) {
      return this.http.put(environment.base_URL + `/tag-translations/${relationId}`, label)
   }
   deleteTranslation(relationId: number) {
      return this.http.delete(environment.base_URL + `/tag-translations/${relationId}`)
   }


   /**
    * Delete Cache
    */

   deleteCache() {

      const memoryCache = ["labels"];

      _.forEach(memoryCache, item => {
         this.cacheService.deleteCache(item);
      })

   }

}
